"use client";

import { ArrowRight, Download, TrendingUp } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "@/components/ui/table";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function Statuskelengkapanlaporan() {
  const {
    ref: headerRef,
    isVisible: headerVisible
  } = useRevealOnScroll<HTMLDivElement>();
  const {
    ref: statsRef,
    isVisible: statsVisible
  } = useRevealOnScroll<HTMLDivElement>();
  const {
    ref: chartRef,
    isVisible: chartVisible
  } = useRevealOnScroll<HTMLDivElement>();
  const {
    ref: tableRef,
    isVisible: tableVisible
  } = useRevealOnScroll<HTMLDivElement>();
  const primaryStats = [{
    number: "127",
    caption: "KONTRIBUTOR DAERAH",
    trend: [45, 62, 84, 95, 107, 118, 127],
    change: "+42% YoY"
  }, {
    number: "850K",
    caption: "PEMBACA BULANAN",
    trend: [420, 540, 655, 710, 780, 810, 850],
    change: "+28% YoY"
  }, {
    number: "15K+",
    caption: "BERITA TERVERIFIKASI",
    trend: [52, 78, 93, 118, 132, 146, 150],
    change: "+15% YoY"
  }];
  const seasonData = [{
    season: "Januari",
    value: 45
  }, {
    season: "Februari",
    value: 58
  }, {
    season: "Maret",
    value: 72
  }, {
    season: "April",
    value: 92
  }, {
    season: "Mei",
    value: 88
  }, {
    season: "Juni",
    value: 76
  }, {
    season: "Juli",
    value: 95
  }];
  const neighborhoods = [{
    name: "Nasional & Politik",
    hives: 42,
    honey: 2450,
    score: 98
  }, {
    name: "Jawa Barat & Garut",
    hives: 35,
    honey: 1820,
    score: 94
  }, {
    name: "Zona Pemuda Pancasila",
    hives: 28,
    honey: 1560,
    score: 92
  }, {
    name: "Klarifikasi & Fakta",
    hives: 15,
    honey: 890,
    score: 89
  }, {
    name: "Kerjasama & Iklan",
    hives: 12,
    honey: 420,
    score: 85
  }];
  const buildSparkPath = (points: number[]) => {
    const width = 120;
    const height = 36;
    const max = Math.max(...points);
    const min = Math.min(...points);
    const range = max - min || 1;
    const step = width / (points.length - 1);
    return points.map((p, i) => {
      const x = i * step;
      const y = height - (p - min) / range * height;
      return `${i === 0 ? "M" : "L"}${x.toFixed(2)},${y.toFixed(2)}`;
    }).join(" ");
  };
  return <section data-section-id="955" id="statuskelengkapanlaporan" className="bg-background text-foreground py-20 md:py-28 px-4 md:px-8 lg:px-12">
      <div className="max-w-7xl mx-auto">
        {}
        <div ref={headerRef} className={`max-w-4xl mb-16 md:mb-20 transition-all duration-700 ${headerVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-6"}`}>
          <div className="flex items-center gap-3 mb-6">
            <span className="w-8 h-px bg-primary" />
            <span className="font-mono text-xs tracking-[0.2em] text-primary uppercase">
              Statistik Portal · Diperbarui Real-time
            </span>
          </div>
          <h2 className="font-serif font-default text-4xl md:text-5xl lg:text-[56px] leading-[1.05] tracking-tight">
            Transparansi data,{" "}
            <em className="text-primary not-italic font-light italic">
              membangun kepercayaan publik
            </em>
          </h2>
        </div>

        {}
        <div ref={statsRef} className={`grid grid-cols-1 md:grid-cols-3 gap-6 md:gap-8 mb-20 md:mb-24 transition-all duration-700 delay-100 ${statsVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-6"}`}>
          {primaryStats.map((stat, i) => <div data-index={i} key={i} className="bg-card border border-border rounded-lg p-8 flex flex-col justify-between min-h-[260px] shadow-sm hover:shadow-md transition-shadow">
              <div>
                <div className="font-serif font-default text-6xl md:text-[88px] leading-none text-primary mb-4">
                  {stat.number}
                </div>
                <div className="font-mono text-[11px] tracking-[0.18em] text-muted-foreground uppercase">
                  {stat.caption}
                </div>
              </div>
              <div className="mt-6 flex items-end justify-between gap-4">
                <svg viewBox="0 0 120 36" className="w-32 h-9 overflow-visible" fill="none" preserveAspectRatio="none">
                  <path d={buildSparkPath(stat.trend)} stroke="var(--primary)" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                </svg>
                <div className="flex items-center gap-1 font-mono text-[11px] tracking-wider text-primary">
                  <TrendingUp className="size-3" />
                  <span>{stat.change}</span>
                </div>
              </div>
            </div>)}
        </div>

        {}
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-10 lg:gap-12 mb-12">
          {}
          <div ref={chartRef} className={`bg-card border border-border rounded-lg p-6 md:p-8 transition-all duration-700 shadow-sm ${chartVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-6"}`}>
            <div className="flex items-start justify-between mb-8">
              <div>
                <div className="font-mono text-[11px] tracking-[0.18em] text-muted-foreground uppercase mb-2">
                  Indeks Aktivitas Berita
                </div>
                <h3 className="font-serif font-default text-2xl md:text-3xl leading-tight">
                  Volume publikasi bulanan
                </h3>
              </div>
              <span className="font-mono text-[10px] tracking-wider text-muted-foreground uppercase whitespace-nowrap">
                2024
              </span>
            </div>

            <div className="relative h-64 md:h-72">
              <div className="absolute inset-0 flex flex-col justify-between pointer-events-none">
                {[100, 75, 50, 25, 0].map((g, i) => <div data-index={i} key={i} className="flex items-center gap-2">
                    <span className="font-mono text-[10px] text-muted-foreground w-6">
                      {g}
                    </span>
                    <div className="flex-1 border-t border-border/40" />
                  </div>)}
              </div>

              <div className="absolute inset-0 pl-8 flex items-end justify-between gap-2 md:gap-3">
                {seasonData.map((d, i) => <div data-index={i} key={i} className="flex-1 flex flex-col items-center justify-end h-full">
                    <div className="w-full rounded-md transition-all duration-1000 ease-out" style={{
                  height: chartVisible ? `${d.value}%` : "0%",
                  background: "linear-gradient(180deg, var(--primary) 0%, var(--chart-4) 100%)",
                  transitionDelay: `${i * 80}ms`
                }} />
                  </div>)}
              </div>
            </div>

            <div className="mt-4 pl-8 flex justify-between gap-2">
              {seasonData.map((d, i) => <span data-index={i} key={i} className="flex-1 text-center font-mono text-[9px] md:text-[10px] tracking-wider text-muted-foreground uppercase">
                  {d.season.substring(0, 3)}
                </span>)}
            </div>
          </div>

          {}
          <div ref={tableRef} className={`bg-card border border-border rounded-lg p-6 md:p-8 transition-all duration-700 delay-100 shadow-sm ${tableVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-6"}`}>
            <div className="flex items-start justify-between mb-8">
              <div>
                <div className="font-mono text-[11px] tracking-[0.18em] text-muted-foreground uppercase mb-2">
                  Jaringan Redaksi
                </div>
                <h3 className="font-serif font-default text-2xl md:text-3xl leading-tight">
                  Performa kanal berita
                </h3>
              </div>
            </div>

            <Table>
              <TableHeader>
                <TableRow className="border-border hover:bg-transparent">
                  <TableHead className="font-mono text-[10px] tracking-[0.15em] text-muted-foreground uppercase pb-4">
                    Kanal Berita
                  </TableHead>
                  <TableHead className="font-mono text-[10px] tracking-[0.15em] text-muted-foreground uppercase pb-4 text-right">
                    Kontributor
                  </TableHead>
                  <TableHead className="font-mono text-[10px] tracking-[0.15em] text-muted-foreground uppercase pb-4 text-right">
                    Artikel
                  </TableHead>
                  <TableHead className="font-mono text-[10px] tracking-[0.15em] text-muted-foreground uppercase pb-4 text-right">
                    Skor
                  </TableHead>
                </TableRow>
              </TableHeader>
              <TableBody>
                {neighborhoods.map((n, i) => <TableRow data-index={i} key={i} className={`border-border/40 hover:bg-primary/5 ${i % 2 === 0 ? "bg-primary/[0.02]" : ""}`}>
                    <TableCell className="py-5 font-default text-sm">
                      {n.name}
                    </TableCell>
                    <TableCell className="py-5 text-right font-mono text-sm tabular-nums">
                      {n.hives}
                    </TableCell>
                    <TableCell className="py-5 text-right font-mono text-sm tabular-nums">
                      {n.honey}
                    </TableCell>
                    <TableCell className="py-5 text-right">
                      <span className="inline-flex items-center gap-1.5 font-mono text-sm tabular-nums text-primary">
                        {n.score}
                      </span>
                    </TableCell>
                  </TableRow>)}
              </TableBody>
            </Table>
          </div>
        </div>

        {}
        <div className="flex justify-end">
          <Button asChild variant="link" className="font-mono text-xs tracking-[0.15em] uppercase text-foreground hover:text-primary px-0">
            <Link to="/EditorialPage">
              <Download className="size-3.5 mr-2" />
              Unduh laporan dampak tahunan (PDF)
              <ArrowRight className="size-3.5 ml-1" />
            </Link>
          </Button>
        </div>
      </div>
    </section>;
}